import React from "react";
import classes from "./Description.module.css";

const Description = ({ category }) => (
  <div className={classes.Description}>
    <img
      src={require(`../../illustrations/${category.image}`).default}
      alt={category.name}
    />
    <h1>{category.name}</h1>
    <p>{category.description}</p>
    <p className={classes.Example}>
      <strong>Example prompt:</strong>
    </p>
    <p style={{ fontStyle: "italic" }}>{category.example}</p>
  </div>
);

export default Description;
